import { Badge } from '../ui/badge';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';

export function PreviousActionItemsSection({ items, editable, onChange }) {
  if (!items || items.length === 0) return null;

  const setOutcome = (id, outcome) => {
    onChange(items.map((it) => (it.id === id ? { ...it, outcome } : it)));
  };

  return (
    <div className="space-y-2" data-testid="previous-action-items">
      {items.map((it) => (
        <div key={it.id} className="flex items-center justify-between border rounded-md p-2 text-sm" data-testid={`previous-action-item-${it.id}`}>
          <div>
            <span className="font-medium">{it.description}</span>
            {it.trainer_name && <span className="text-muted-foreground"> — trainer: {it.trainer_name}</span>}
          </div>
          {editable && !it.outcome ? (
            <Select value={it.outcome || ''} onValueChange={(v) => setOutcome(it.id, v)}>
              <SelectTrigger className="w-32" data-testid={`previous-action-item-outcome-${it.id}`}><SelectValue placeholder="Outcome" /></SelectTrigger>
              <SelectContent>
                <SelectItem value="DONE">Done</SelectItem>
                <SelectItem value="NOT_DONE">Not done</SelectItem>
              </SelectContent>
            </Select>
          ) : (
            <Badge className={it.outcome === 'DONE' ? 'bg-emerald-100 text-emerald-800' : it.outcome === 'NOT_DONE' ? 'bg-red-100 text-red-800' : 'bg-slate-100 text-slate-700'}>
              {it.outcome || 'Pending outcome'}
            </Badge>
          )}
        </div>
      ))}
    </div>
  );
}
